// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Link$Showside from "./Link.bs.js";
import * as Unicons$Showside from "../icons/Unicons.bs.js";
import * as IconCart$Showside from "../icons/IconCart.bs.js";
import * as Favorites$Showside from "./Favorites.bs.js";
import * as IconButton$Showside from "./IconButton.bs.js";
import * as StringUtils$Showside from "../utils/StringUtils.bs.js";
import * as CartAnimation$Showside from "./CartAnimation.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as UseCheckoutAction$Showside from "../hook/UseCheckoutAction.bs.js";
import * as CartContextProvider$Showside from "../context/CartContextProvider.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function PDPNavbar(Props) {
  var closeOpt = Props.close;
  var homeOpt = Props.home;
  var backOpt = Props.back;
  var close = closeOpt !== undefined ? closeOpt : true;
  var home = homeOpt !== undefined ? homeOpt : true;
  var back = backOpt !== undefined ? backOpt : true;
  var match = ConfigurationProvider$Showside.use(undefined).config;
  var settings = match.settings;
  var match$1 = ViewportContext$Showside.use(undefined);
  var isMobile = match$1.isMobile;
  var match$2 = EntrypointContext$Showside.use(undefined);
  var onBackClick = match$2.onBackClick;
  var onCloseNavigation = match$2.onCloseNavigation;
  var onHomeClick = match$2.onHomeClick;
  var embedType = match$2.embedType;
  var match$3 = CartContextProvider$Showside.useCart(undefined);
  var cart = match$3.cart;
  var match$4 = RouterProvider$Showside.useRouter(undefined);
  var isSmartbar = settings.smartbarEnabled;
  var isDesktopBar = settings.smartbarEnabled && !isMobile;
  var isDesktopInline = embedType === /* Inline */1 && !isMobile;
  var renderBackButton = function (param) {
    return React.createElement(IconButton$Showside.make, {
      onClick: function (param) {
        Curry._1(onBackClick, undefined);
      },
      shadow: true,
      icon: React.createElement(Unicons$Showside.UilAngleLeftB.make, {
        size: /* Px */{
          _0: 26
        }
      }),
      title: "Back",
      dataTestId: "pdp-button-back",
      className: CSS$Showside.prefix("ml-0.5 mr-2 -top-px pointer-events-auto")
    });
  };
  var renderHomeButton = function (param) {
    if (embedType >= 4) {
      return null;
    } else {
      return React.createElement(IconButton$Showside.make, {
        onClick: function (param) {
          Curry._1(onHomeClick, undefined);
        },
        shadow: true,
        icon: React.createElement(Unicons$Showside.UilEstate.make, {
          size: /* Px */{
            _0: 21
          }
        }),
        title: "Home",
        dataTestId: "pdp-button-home",
        className: CSS$Showside.prefix("-top-px pointer-events-auto")
      });
    }
  };
  var match$5 = UseCheckoutAction$Showside.useCheckoutAction(undefined);
  var checkoutOnClick = match$5.onClick;
  var checkoutHref = match$5.href;
  var renderCheckoutButton = function (param) {
    if (checkoutHref === undefined && checkoutOnClick === undefined) {
      return null;
    }
    var tmp = {
      children: null,
      unstyled: true,
      className: CSS$Showside.prefix("relative w-12 h-12"),
      ariaLabel: "Checkout"
    };
    if (checkoutHref !== undefined) {
      tmp.href = Caml_option.valFromOption(checkoutHref);
    }
    if (checkoutOnClick !== undefined) {
      tmp.onClick = Caml_option.valFromOption(checkoutOnClick);
    }
    var tmp$1 = {
      shadow: true,
      icon: React.createElement(IconCart$Showside.make, {
        size: 22
      }),
      title: "Checkout",
      dataTestId: "pdp-button-checkout",
      iconClassName: CSS$Showside.prefix("-ml-px -mt-px"),
      className: CSS$Showside.prefix("mr-0.5 -top-px")
    };
    var tmp$2 = StringUtils$Showside.fromInt(99, undefined, cart.itemCount);
    if (tmp$2 !== undefined) {
      tmp$1.badge = Caml_option.valFromOption(tmp$2);
    }
    return React.createElement(React.Fragment, undefined, React.createElement("div", {
      className: CSS$Showside.prefix("relative pointer-events-auto")
    }, React.createElement(Link$Showside.make, tmp, React.createElement(IconButton$Showside.make, tmp$1), React.createElement(CartAnimation$Showside.make, {
      productDirection: /* Bottom */1,
      tooltipDirection: /* Left */2,
      addedLabel: settings.pdpAddToCartConfirmation,
      className: CSS$Showside.prefix("absolute w-full h-full")
    }))));
  };
  var renderFavoritesButton = function (param) {
    if (embedType >= 4 || !settings.favoritesEnabled) {
      return null;
    } else {
      return React.createElement(Favorites$Showside.OpenButton.make, {
        at: /* PDP */1
      });
    }
  };
  var renderCloseButton = function (param) {
    return React.createElement(IconButton$Showside.make, {
      onClick: function (param) {
        if (embedType === /* Inline */1) {
          return Curry._1(onBackClick, undefined);
        } else {
          return Curry._1(onCloseNavigation, undefined);
        }
      },
      shadow: true,
      icon: React.createElement(Unicons$Showside.UilTimes.make, {
        size: /* Px */{
          _0: 28
        }
      }),
      title: "Close",
      dataTestId: "pdp-button-open-close",
      className: CSS$Showside.prefix("mr-0.5 ml-2 -top-px pointer-events-auto")
    });
  };
  return React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["absolute", "top-0", "left-0", "px-4", "pt-1.5", "z-30", "flex", "flex-row", "w-full", "pointer-events-none", match$4.isQuickView || embedType !== 0 || !(isMobile && isSmartbar) ? "mt-1" : "-mt-4"]))
  }, back ? renderBackButton(undefined) : null, (isDesktopBar || isDesktopInline) && home ? renderHomeButton(undefined) : null, React.createElement("div", {
    className: CSS$Showside.prefix("flex-grow flex justify-end")
  }, renderFavoritesButton(undefined), isDesktopBar || isMobile || isDesktopInline ? renderCheckoutButton(undefined) : null), close && (isDesktopBar || isDesktopInline) ? renderCloseButton(undefined) : null);
}
PDPNavbar.displayName = "PDPNavbar";
var make = PDPNavbar;
export { make };
/* react Not a pure module */